import type { Booking } from '@brighterly/lib-core-types/booking/interfaces'
import type { CalendarTooltip } from '@shared/ui/calendars'

import { DateFormat } from '@brighterly/lib-core-types/date/enums'

import { formatDefaultDate, formatIsoDate, formatTimeAmPm } from '@shared/lib/format'

const byStart = (a: Booking, b: Booking): number => a.start.localeCompare(b.start)

const getLessonTimes = (lessons: Booking[]): string => {
  const [timeZone, ...otherTimeZones] = new Set(lessons.map(lesson => lesson.booked_timezone_abbr))
  const sharesOneTimeZone = otherTimeZones.length === 0

  if (sharesOneTimeZone) return `${lessons.map(lesson => formatTimeAmPm(lesson.start)).join(', ')} (${timeZone})`

  return lessons.map(lesson => `${formatTimeAmPm(lesson.start)} (${lesson.booked_timezone_abbr})`).join(', ')
}

export const getLessonTooltips = (bookings: Booking[], discipline: string): CalendarTooltip[] => {
  const dates = [...new Set(bookings.map(booking => formatDefaultDate(booking.start)))]

  return dates.map((date) => {
    const lessons = bookings.filter(booking => formatDefaultDate(booking.start) === date).sort(byStart)
    const noun = lessons.length === 1 ? 'lesson' : 'lessons'

    return {
      date,
      title: formatIsoDate(date, DateFormat.BookedDate),
      description: `${discipline} ${noun} at ${getLessonTimes(lessons)}`,
    }
  })
}
